import { ReleaseNotesProduct } from '../types/release-notes/ReleaseNotesProduct';

import { getReleaseNotesPath } from './RoutesHelper';

export const getActiveNavigationItem = (
	topLevelProducts: ReleaseNotesProduct[],
	selectedProduct: ReleaseNotesProduct | null,
	subproductSlug?: string
): string => {
	if (!selectedProduct) {
		return '';
	}

	// If we have a subproduct slug, find the parent product
	if (subproductSlug) {
		const parentProduct = topLevelProducts.find((product) =>
			product.sub_products?.some((sub) => sub.slug === subproductSlug)
		);
		if (parentProduct) {
			return getReleaseNotesPath(parentProduct.slug, subproductSlug);
		}
	}

	// For main products (no subproducts)
	return getReleaseNotesPath(selectedProduct.slug);
};
